import React, { useEffect, useState } from 'react'
import { getAdmin, getBatch, getCategory, getSection, getTag, getType } from '../Redux/BatchSectionReducer/action';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import MDEditor from '@uiw/react-md-editor';
import { Field, Form, Formik } from 'formik';
import { setLecture } from '../Redux/LectureReducer/action';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';

const FormSchema = yup.object().shape({
    title: yup.string().required("Title is required").min(3, "Title must be 3 character"),
    category: yup.string().required("Category is required"),
    batch: yup.string().required("Batch is required"),
    section: yup.string().required("Section is required"),
    type: yup.string().required("Type is required"),
    schedule: yup.string().required("Schedule date and time is required is required"),
    concludes: yup.string().required("Concludes date and time is required"),
    tags: yup.string().required("Tag is required"),
    user: yup.string().required("User is required"),
    optional: yup.string().required("Optional is required"),
    hideVideo: yup.string().required("Hide video is required"),
    zoomLink: yup.string().required("Zoom link is required")
        .matches(/^https:\/\/[a-z0-9-]+\.zoom\.us\/j\/\d{10,}$/, "Please enter a valid zoom link"),
    day: yup.string().required("Day is required")
        .matches(/[1-6]/, "Day must be between 1-6"),
    week: yup.string().required("Week is required")
        .matches(/[1-5]/, "Week must be between 1 to 5"),
});


export const CopyLecture = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { state } = useLocation();
    const data = state.data;
    console.log(data);
    const batch = useSelector((state) => state.BatchSectionReducer.batch);
    const section = useSelector((state) => state.BatchSectionReducer.section);
    const tag = useSelector((state) => state.BatchSectionReducer.tag);
    const type = useSelector((state) => state.BatchSectionReducer.type);
    const token = useSelector((state) => state.AuthReducer.token)
    const category = useSelector((state) => state.BatchSectionReducer.category);
    const admin = useSelector((state) => state.BatchSectionReducer.admin);
    const user = useSelector((state) => state.AuthReducer.user);
    const optionalValue = data.optional === "true" ? true : false
    const hideValue = data.hideVideo === "true" ? true : false
    const [optional, setOptional] = useState(optionalValue);
    const [hideVideo, setHideVideo] = useState(hideValue);
    const [noteValue, setNotevalue] = useState(data.notes);

    category.map((e) => {
        if (data.category == e.categoryTitle) {
            data.category = e.categoryId
        }
    })
    batch.map((e) => {
        if (data.batch === e.batchName) {
            data.batch = e.id;
        }
    })
    section.map((e) => {
        if (data.section === e.sectionsName) {
            data.section = e.id;
        }
    })
    type.map((e) => {
        if (data.type === e.typeTitle) {
            data.type = e.typeId;
        }
    })
    tag.map((e) => {
        if (data.tag === e.tagTitle) {
            data.tag = e.tagId;
        }
    })
    admin.map((e) => {
        if (data.createdBy === e.name) {
            data.createdBy = e.id;
        }
    })

    // taking lecture schedule start and time to update it on form
    const lectureStartTimeArray = state.data.startTime.split(" ");
    const lectureStartDate = lectureStartTimeArray[0].split("/").join("-");
    const lectureStartTime = lectureStartTimeArray[1].split(":").slice(0, 2).join(":");

    // taking lecture concludes date and time to update it on form 
    const lectureEndTimeArray = state.data.concludeTime.split(" ");
    const lectureEndDate = lectureEndTimeArray[0].split("/").join("-");
    const lectureEndTime = lectureEndTimeArray[1].split(":").slice(0, 2).join(":");

    // -------------takinc current date and time for validation --------------
    let currDateTime = new Date();
    let dateString = currDateTime.toLocaleDateString();
    let dateArray = dateString.split('/').map(Number);
    let timeString = currDateTime.toLocaleTimeString('en-US', {
        hour12: false,
        hour: "numeric",
        minute: "numeric"
    });

    let timeArray = timeString.split(":").map(Number);
    const setDateTime = (value) => {
        if (value < 10) {
            return `0${value}`
        } else {
            return value;
        }
    }

    let month = setDateTime(dateArray[0]);
    let date = setDateTime(dateArray[1]);
    let year = setDateTime(dateArray[2]);
    let hour = setDateTime(timeArray[0]);
    let min = setDateTime(timeArray[1]);

    const handleSubmit = (values) => {
        // ------- accessing schedule date time to correct the formate -----------
        const scheduleArray = values.schedule.split("T")
        const scheduleDateArray = scheduleArray[0].split("-");
        const [scheduleYear, scheduleMonth, scheduleDate] = scheduleDateArray;
        const scheduleTimeArray = scheduleArray[1].split(":");
        const [schedulehour, schedulemin] = scheduleTimeArray;

        // ------- accessing concludes date time to correct the formate -----------
        const concludesArray = values.concludes.split("T")
        const concludesDateArray = concludesArray[0].split("-");
        const [concludesYear, concludesMonth, concludesDate] = concludesDateArray;
        const concludesTimeArray = concludesArray[1].split(":");
        const [concludeshour, concludesmin] = concludesTimeArray;

        let data = {
            title: values.title,
            "createdBy": values.user,
            "updatedBy": user.name,
            "copyLectureFrom": id,
            categoryId: values.category,
            batchId: values.batch,
            sectionId: values.section,
            startTime: `${scheduleYear}/${scheduleMonth}/${scheduleDate} ${schedulehour}:${schedulemin}:00`,
            concludeTime: `${concludesYear}/${concludesMonth}/${concludesDate} ${concludeshour}:${concludesmin}:00`,
            tagId: values.tags,
            typeId: values.type,
            optional: values.optional,
            hideVideo: values.hideVideo,
            zoomLink: values.zoomLink,
            day: values.day,
            week: values.week,
            notes: noteValue,
        }
        console.log(data);
        dispatch(setLecture(data, token)).then((res) => {
            if (res === "Lecture Added successfully") {
                alert("Lecture Added successfully")
                navigate('/lecture')
            }
        })
    }

    useEffect(() => {
        dispatch(getSection(token));
        dispatch(getBatch(token));
        dispatch(getType());
        dispatch(getTag());
        dispatch(getCategory());
        dispatch(getAdmin());
    }, [])

    return (
        <div className='font-sans antialiased min-h-screen bg-gray-100'>
            <nav>
                <Navbar name={user.name} role={user.roles.name} />
            </nav>
            <header className='bg-white shadow'>
                <div className='max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex justify-between'>
                    <h2 className='font-semibold text-xl text-start text-gray-800 leading-tight'> Copy Lecture</h2>
                </div>
            </header>
            <div className='py-12'>
                <div className='max-w-7xl mx-auto sm:px-6 lg:px-8'>
                    <div className='bg-white m-auto mt-10 sm:mt-0'>
                        <Formik
                            initialValues={{
                                title: data.title,
                                category: data.category,
                                batch: data.batch,
                                section: data.section,
                                type: data.type,
                                schedule: `${lectureStartDate}T${lectureStartTime}`,
                                concludes: `${lectureEndDate}T${lectureEndTime}`,
                                tags: data.tag,
                                user: data.createdBy,
                                optional: data.optional,
                                hideVideo: data.hideVideo,
                                zoomLink: data.zoomLink,
                                day: data.day,
                                week: data.week,
                                notes: data.notes
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            validationSchema={FormSchema}
                            onSubmit={(values) => handleSubmit(values)}
                        >
                            {({ errors }) => (
                                <Form className='p-6 text-left grid grid-cols-12 gap-6'>
                                    <div className='col-span-12'>
                                        <label className='block font-medium text-sm text-gray-700'>Title</label>
                                        <Field
                                            name="title"
                                            className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                            type='text'
                                        />
                                        {errors.title && <p className="text-red-600 text-sm">{errors.title}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Category</label>
                                        <Field
                                            component="select"
                                            name="category"
                                            className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                        >
                                            <option value="">Category</option>
                                            {
                                                category.map((e) => {
                                                    return <option key={e.categoryId} value={e.categoryId} >{e.categoryTitle}</option>
                                                })
                                            }
                                        </Field>
                                        {errors.category && <p className="text-red-600 text-sm">{errors.category}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Batch</label>
                                        <Field
                                            component="select"
                                            name="batch"
                                            className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                        >
                                            <option value="">Batch</option>
                                            {
                                                batch.map((e) => {
                                                    return <option key={e.id} value={e.id}>{e.batchName}</option>
                                                })
                                            }
                                        </Field>
                                        {errors.batch && <p className="text-red-600 text-sm">{errors.batch}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Section</label>
                                        <Field
                                            component="select"
                                            name="section"
                                            className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                        >
                                            <option value="">Section</option>
                                            {
                                                section.map((e) => {
                                                    return <option key={e.id} value={e.id}>{e.sectionsName}</option>
                                                })
                                            }
                                        </Field>
                                        {errors.section && <p className="text-red-600 text-sm">{errors.section}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Type</label>
                                        <Field
                                            component="select"
                                            name="type"
                                            className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                        >
                                            <option value="">Type</option>
                                            {
                                                type.map((e) => {
                                                    return <option key={e.typeId} value={e.typeId}>{e.typeTitle}</option>
                                                })
                                            }
                                        </Field>
                                        {errors.type && <p className="text-red-600 text-sm">{errors.type}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Schedule</label>
                                        <Field
                                            name="schedule"
                                            className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                            type='datetime-local'
                                            step="60"
                                            min={`${year}-${month}-${date}T${hour}:${min}`}
                                        />
                                        {errors.schedule && <p className="text-red-600 text-sm">{errors.schedule}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Concludes</label>
                                        <Field
                                            name="concludes"
                                            className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                            type='datetime-local'
                                            step="60"
                                            min={`${year}-${month}-${date}T${hour}:${min}`}
                                        />
                                        {errors.concludes && <p className="text-red-600 text-sm">{errors.concludes}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Tags</label>
                                        <Field
                                            component="select"
                                            name="tags"
                                            className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                        >
                                            <option value="">Tags</option>
                                            {
                                                tag.map((e) => {
                                                    return <option key={e.tagId} value={e.tagId}>{e.tagTitle}</option>
                                                })
                                            }
                                        </Field>
                                        {errors.tags && <p className="text-red-600 text-sm">{errors.tags}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>User</label>
                                        <Field
                                            component="select"
                                            name="user"
                                            className='text-sm p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                        >
                                            <option value="">User</option>
                                            {
                                                admin.map((e) => {
                                                    return <option key={e.id} value={e.id}>{e.name}</option>
                                                })
                                            }
                                        </Field>
                                        {errors.user && <p className="text-red-600 text-sm">{errors.user}</p>}
                                    </div>
                                    <div className='col-span-4 flex justify-between items-center pt-4'>
                                        <div className='flex items-center gap-4'>
                                            <label className='font-medium text-sm text-gray-700'>Optional</label>
                                            <input
                                                type='checkbox'
                                                name='optional'
                                                className='items-end'
                                                value={optional}
                                                checked={optional ? true : false}
                                                onChange={() => setOptional(!optional)}
                                            />
                                        </div>
                                        <div className='flex items-center gap-4'>
                                            <label className='font-medium text-sm text-gray-700'>Hide Video</label>
                                            <input
                                                type='checkbox'
                                                name='hideVideo'
                                                className='items-end'
                                                value={hideVideo}
                                                checked={hideVideo ? true : false}
                                                onChange={() => setHideVideo(!hideVideo)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-span-12'>
                                        <label className='block font-medium text-sm text-gray-700'>Zoom Link</label>
                                        <Field
                                            name="zoomLink"
                                            className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                            type='text'
                                        />
                                        {errors.zoomLink && <p className="text-red-600 text-sm">{errors.zoomLink}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Day</label>
                                        <Field
                                            name="day"
                                            className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                            type='number'
                                        />
                                        {errors.day && <p className="text-red-600 text-sm">{errors.day}</p>}
                                    </div>
                                    <div className='col-span-4'>
                                        <label className='block font-medium text-sm text-gray-700'>Week</label>
                                        <Field
                                            name="week"
                                            className='text-sm required:border-red-500 p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full'
                                            type='number'
                                        />
                                        {errors.week && <p className="text-red-600 text-sm">{errors.week}</p>}
                                    </div>
                                    <div className='col-span-12'>
                                        <label className='block font-medium text-sm text-gray-700'>Notes:</label>
                                        <div data-color-mode="light">
                                            <MDEditor name="notes" height={300} value={noteValue} onChange={setNotevalue} />
                                        </div>
                                    </div>
                                    <div className='w-40'>
                                        <button type='submit' className='border w-full rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer '>Create Lecture</button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
}
